import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  padding: 8px 12px;
  height: 37px;
  background: ${(prop) => prop.theme.colors['secondary-20']};
  border: 1px solid ${(prop) => prop.theme.colors['primary-40']};
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['primary-40']};
`;

export const Score = styled.span`
  color: ${(prop) => prop.theme.colors['primary-60']};
  margin-left: 12px;
`;
